export default "__VITE_ASSET__MrHxKQCG__"